import { Layout } from 'antd';
import { ReactNode } from 'react';

import { DspTabs } from '../DspTabs/DspTabs';

const { Header: HeaderAntd } = Layout;

export type HeaderProps = {
  children: ReactNode;
};

export const Header = ({ children }: HeaderProps) => {
  return (
    <HeaderAntd className="ctv-header p-0 bg-white border-b border-solid border-b-1 border-primary-gray-100">
      <div className="h-16 flex justify-between items-center px-8">
        {/* Left side: DSP Tabs */}
        <DspTabs />

        {/* Right side: User controls */}
        <div className="flex items-center gap-3">{children}</div>
      </div>
    </HeaderAntd>
  );
};
